// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"09135836","340":"0021c7bd","380":"0e44f3ed","960":"26d65d0c"}[chunkId] + ".chunk.js";
};